import React, { forwardRef } from "react";
import IconBase, { IconProps } from "./icon-base";

const TrashIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  // parse width and height from props as number
  let width = props.width ?? props.size ?? 14;
  if (typeof width === "string") {
    width = parseInt(width);
  }
  let height = props.height ?? props.size ?? width / (14 / 15);
  if (typeof height === "string") {
    height = parseInt(height);
  }

  return (
    <IconBase
      width={width}
      height={height}
      viewBox="0 0 14 15"
      ref={ref}
      renderPath={(color: string) => {
        return (
          <>
            <path
              d="M1 3.88892H12.5556"
              stroke={color}
              strokeLinecap="square"
              strokeLinejoin="round"
              fill={"transparent"}
            />
            <path
              d="M5.3335 6.77783V11.1112"
              stroke={color}
              strokeLinecap="square"
              strokeLinejoin="round"
              fill={"transparent"}
            />
            <path
              d="M8.22217 6.77783V11.1112"
              stroke={color}
              strokeLinecap="square"
              strokeLinejoin="round"
              fill={"transparent"}
            />
            <path d="M2 4.5L2.5 14H11L11.5 4" stroke={color} strokeLinecap="square" fill={"transparent"} />
            <path
              d="M4.61084 3.88889V1.72222C4.61084 1.53068 4.68693 1.34698 4.82237 1.21153C4.95782 1.07609 5.14152 1 5.33306 1H8.22195C8.4135 1 8.5972 1.07609 8.73264 1.21153C8.86808 1.34698 8.94417 1.53068 8.94417 1.72222V3.88889"
              stroke={color}
              strokeLinecap="square"
              strokeLinejoin="round"
              fill={"transparent"}
            />
          </>
        );
      }}
      {...props}
    >
      {props.children}
    </IconBase>
  );
});

TrashIcon.displayName = "TrashIcon";

export { TrashIcon };

export const CimTrashIcon = ({
  color = "#1e1e1e",
  width = 11,
  height = 13,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 11 13" fill="none">
      <path d="M0.5 3H10.5" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.25 5.5V9.25" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.75 5.5V9.25" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M1.125 3L1.75 10.5C1.75 10.8315 1.8817 11.1495 2.11612 11.3839C2.35054 11.6183 2.66848 11.75 3 11.75H8C8.33152 11.75 8.64946 11.6183 8.88388 11.3839C9.1183 11.1495 9.25 10.8315 9.25 10.5L9.875 3"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.625 3V1.125C3.625 0.95924 3.69085 0.800268 3.80806 0.683058C3.92527 0.565848 4.08424 0.5 4.25 0.5H6.75C6.91576 0.5 7.07473 0.565848 7.19194 0.683058C7.30915 0.800268 7.375 0.95924 7.375 1.125V3"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
